/**
 * Standard bottom navigation bar — replaces every floating "back" arrow in
 * the app with a labeled circle row. Pass the circles you want via `items`.
 *
 * Per-item shape:
 *   { key, icon, label, variant: 'primary' | 'inverse' (default), onClick }
 *
 *   - 'primary'  — gold-filled, dark icon. Use for the Home/center destination.
 *   - 'inverse'  — dark fill, gold icon. Use for parent-back destinations
 *                  (Single Player, Daily, Multiplayer, etc.).
 *
 * No ticket badges are rendered here — circles that spend a ticket (Replay,
 * New Game) open the existing yin/yang confirmation modal on tap, and only
 * spend on confirm. See the handoff doc.
 *
 * Example — nested screen with a Single Player + Home pair:
 *   import { IconArrowLeft, IconHome } from './icons'
 *   <BottomNav items={[
 *     { key: 'parent', icon: IconArrowLeft, label: 'Single Player', variant: 'inverse', onClick: onBack },
 *     { key: 'home',   icon: IconHome,      label: 'Home',          variant: 'primary', onClick: onHome },
 *   ]} />
 *
 * Example — top-level info screen with just Home:
 *   <BottomNav items={[
 *     { key: 'home', icon: IconHome, label: 'Home', variant: 'primary', onClick: onHome },
 *   ]} />
 */

function NavCircle({ icon: Icon, label, variant = 'inverse', onClick }) {
  return (
    <div className="navc">
      <button
        type="button"
        className={`navc__btn navc__btn--${variant}`}
        aria-label={label}
        title={label}
        onClick={onClick}
      >
        <Icon size={24} />
      </button>
      <span className="navc__label">{label}</span>
    </div>
  )
}

export default function BottomNav({ items }) {
  return (
    <nav className="bottom-nav" aria-label="Screen navigation">
      {items.map((it) => (
        <NavCircle key={it.key} {...it} />
      ))}
    </nav>
  )
}
